import { render, staticRenderFns } from "./CustomerBlockReasons.vue?vue&type=template&id=e34509fa&scoped=true"
import script from "./CustomerBlockReasons.vue?vue&type=script&lang=js"
export * from "./CustomerBlockReasons.vue?vue&type=script&lang=js"
import style0 from "./CustomerBlockReasons.vue?vue&type=style&index=0&id=e34509fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e34509fa",
  null
  
)

export default component.exports